// extracted by mini-css-extract-plugin
export default {"navItemText":"header_navItemText__pggB7","logo":"header_logo__tVpBR"};